<template>
  <div>
    <div
      class="no-branch"
      :style="[isMobile ? { top: '280px' } : { top: '110px' }]"
    >
      کاربر محترم: در حال حاضر سامانه تغذیه برای مدرسه شما فعال نیست.
      <img class="food-image" :src="require(`../assets/empty-plate.png`)" />
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>

<style scoped>
.no-branch {
  text-align: center;
  color: black;
  font-size: 1.2em;
  position: fixed;

  left: 25%;
  transform: translate(-15%, 0);
}
.food-image {
  border-style: none;
  min-width: 50%;
  max-width: 90%;
  display: block;
  margin: 50px auto;
}
</style>

